import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'annual_purchase_volume'

export const dataPointDefinition = {
  retracedId: 'annual_purchase_volume',
  name: 'Annual Purchase Volume',
  meta: {},
  fieldTypeId: 'NUMBER_DYNAMIC_CURRENCY_WITH_YEAR',
  type: 'TRANSACTIONAL',
  options: [],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'number',
      },
      year: {
        type: 'number',
        minimum: 1000,
        maximum: 9999,
      },
      unit: {
        type: 'string',
      },
    },
    required: ['value', 'year', 'unit'],
  },
  externalIds: [],
  sortingId: 460,
  sectionId: '1.3',
  impactArea: 'Operational Metrics',
  impactAreaId: 'OPERATIONAL_METRICS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
